/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentPolicyGrantForm,
  AgentPolicyGrantForm$Outbound,
  AgentPolicyGrantForm$outboundSchema,
} from "./agentpolicygrantform.js";

export type CheckAgentPolicyGrantsForm = {
  /**
   * The agent the grants would be written to. Omit for an agent the caller would create.
   */
  agentId?: string | undefined;
  /**
   * Owner of the agent the caller would create, as agents.create takes it; defaults to the caller. Not allowed with agent_id, whose owner is its own.
   */
  ownerUserId?: string | undefined;
  /**
   * The grants to check, answered in the same order.
   */
  policyGrants: Array<AgentPolicyGrantForm>;
};

/** @internal */
export type CheckAgentPolicyGrantsForm$Outbound = {
  agent_id?: string | undefined;
  owner_user_id?: string | undefined;
  policy_grants: Array<AgentPolicyGrantForm$Outbound>;
};

/** @internal */
export const CheckAgentPolicyGrantsForm$outboundSchema: z.ZodMiniType<
  CheckAgentPolicyGrantsForm$Outbound,
  CheckAgentPolicyGrantsForm
> = z.pipe(
  z.object({
    agentId: z.optional(z.string()),
    ownerUserId: z.optional(z.string()),
    policyGrants: z.array(AgentPolicyGrantForm$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      ownerUserId: "owner_user_id",
      policyGrants: "policy_grants",
    });
  }),
);

export function checkAgentPolicyGrantsFormToJSON(
  checkAgentPolicyGrantsForm: CheckAgentPolicyGrantsForm,
): string {
  return JSON.stringify(
    CheckAgentPolicyGrantsForm$outboundSchema.parse(checkAgentPolicyGrantsForm),
  );
}
